import { login, getInfo } from '@/api/login'
import { setVersion, getToken, setToken, removeToken, getOriginToken, getVersion } from '@/utils/auth'
import Cookies from 'js-cookie'
function filterPermissions(new_per_list) {
  if (new_per_list && new_per_list instanceof Array && new_per_list.length > 0) {
    let permissions = []
    new_per_list.forEach(item => {
      item.child.forEach(operate => {
        permissions.push(`*${item.label}*${operate.Name}*`)
      })
    })
    return permissions
  } else {
    return []
  }
}
const user = {
  state: {
    token: getToken(),
    isVersion: 0,
    ogToken: getOriginToken() || '',
    isTravel: 0,
    name: '',
    id: '',
    avatar: '',
    usertime: '',
    company: '',
    Logo: '',
    is_access_iams: false,
    country_name_en: '',
    DNC: false,
    product_and_permission: {
      products: [],
      permissions: []
    },
    roles: [],
    intentionTags: {
      collection: [],
      marketing: [],
      info_check: []
    },
    isShowLicenseTip: false,
    show_dashboard: {},
    userInfo: {},
    iams_permission: [],
    language: Cookies.get('language') || 'zh',
    permissions: [],
    detail_language: Cookies.get('language') || 'zh',
    mode: '',
    viewNumber: false,
    isAddTask: false,
    isAddPlan: false,
    loginInfo: {
      isShow: false,
      last_login_time: '',
      region: ''
    }
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_MODE: (state, mode) => {
      state.mode = mode
    },
    SET_ISVERSION: (state, version) => {
      state.isVersion = version
    },
    SET_OGTOKEN: (state, token) => {
      state.ogToken = token
    },
    SET_COUNTRY_NAME: (state, val) => {
      state.country_name_en = val
    },
    SET_ISTRAVEL: (state, travel) => {
      state.is_travel = travel
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_LOGO: (state, Logo) => {
      state.Logo = Logo
    },
    SET_APPROVAL: (state, approval) => {
      state.isAddTask = approval.add_task === 1
      state.isAddPlan = approval.add_plan === 1
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PRODUCT_AND_PERMISSION: (state, product_and_permission) => {
      state.product_and_permission = product_and_permission
    },
    SET_USERTIME: (state, usertime) => {
      state.usertime = usertime
    },
    SET_COMPANY: (state, company) => {
      state.company = company
    },
    SET_IS_ACCESS_IAMS: (state, value) => {
      state.is_access_iams = value
    },
    SET_DNC: (state, value) => {
      state.DNC = value
    },
    SET_INTENTION_TAGS: (state, intentionTags) => {
      state.intentionTags = intentionTags
    },
    SET_SHOW_DASHBOARD: (state, show_dashboard) => {
      state.show_dashboard = show_dashboard
    },
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_IAMS_PERMISSIONS: (state, iams_permission) => {
      state.iams_permission = iams_permission
    },
    SET_DETAIL_LANGUAGE: (state, detail_language) => {
      state.detail_language = detail_language
    },
    SET_SHOW_LICENSE_TIP: (state, payload) => {
      state.isShowLicenseTip = payload
    },
    SET_LOGIN_INFO: (state, payload) => {
      state.loginInfo.isShow = true
      state.loginInfo.last_login_time = payload.last_login_time
      state.loginInfo.region = payload.region
    },
    CLOSE_LOGIN_INFO: state => {
      state.loginInfo.isShow = false
    },
    SET_VIEW_NUMBER: (state, value) => {
      state.viewNumber = value
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password, userInfo.certificate)
          .then(response => {
            if (response.data.code !== 200) {
              resolve({
                verifyType: 'needShowError',
                showCode: response.data.code,
                detailData: response.data.data,
                status: response.data.status
              })
            } else {
              const data = response.data.data
              if (data.needcheck) {
                resolve({
                  verifyType: 'needCheck',
                  code: data.needcheck
                })
              } else if (data.user_status !== 1) {
                resolve({
                  verifyType: 'needEdit',
                  code: data.user_status,
                  userId: data.user_id,
                  token: data.token
                })
              } else {
                setToken(data.token)
                commit('SET_TOKEN', data.token)
                // 登录后展示 License 过期提示(有对应提示就展示)
                commit('SET_SHOW_LICENSE_TIP', true)
                if (data.login_tips && JSON.stringify(data.login_tips) !== '{}') {
                  resolve({
                    verifyType: 'showLoginTip',
                    login_tips: data.login_tips
                  })
                } else {
                  resolve()
                }
              }
            }
          })
          .catch(error => {
            console.info(error)
            reject(error)
          })
      })
    },
    SSOLogin({ commit }, token) {
      return new Promise(resolve => {
        setToken(token)
        commit('SET_TOKEN', token)
        resolve()
      })
    },

    // 获取用户信息
    GetInfo({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token, getVersion() || '')
          .then(response => {
            const data = response.data.data
            setVersion(data.version)
            commit('SET_ISVERSION', data.version_new)
            if (data.is_access_iams) {
              let temp = {
                products: [],
                permissions: [],
                new_per_list: []
              }
              let activeName = sessionStorage.getItem('activeName')
              let isHaveActiveName = false
              for (let i of data.iams_permission.parent) {
                temp.products.push(i.perms)
              }

              for (let i of temp.products) {
                if (activeName == i) {
                  isHaveActiveName = true
                }
              }
              if (!isHaveActiveName) {
                if (temp.products.length > 0) {
                  activeName = temp.products[0]
                  sessionStorage.setItem('activeName', temp.products[0])
                }
              }
              // 路由权限的处理，直接取所有
              let routerTemp = {
                products: [],
                permissions: [],
                new_per_list: []
              }
              for (let i of data.iams_permission.parent) {
                routerTemp.products.push(i.perms)
              }
              for (let i of data.iams_permission.menu) {
                routerTemp.permissions.push(i.perms)
              }
              let routerChild = []
              for (let i of data.iams_permission.menu) {
                let haveParent = false
                for (let j of data.iams_permission.menu) {
                  if (i.id === j.pid) {
                    haveParent = true
                  }
                }
                if (!haveParent) {
                  routerChild.push({
                    id: i.id,
                    label: i.perms,
                    child: []
                  })
                }
              }
              for (let i of routerChild) {
                for (let j of data.iams_permission.resource) {
                  if (i.id === j.pid) {
                    i.child.push({ Name: j.perms })
                  }
                }
              }
              for (let i of routerChild) {
                i.child.push({ Name: 'view' })
              }
              routerTemp.new_per_list = routerChild
              data.routerProducePermissions = routerTemp
              // 产品权限的隔离，不配做取所有
              let type = {
                normal: 'collection',
                promotion: 'marketing',
                ic: 'info_check',
                cod: 'cod',
                chatbot: 'chatbot',
                Inbound: 'Inbound'
              }
              const typeArr = Object.values(type)
              data.iams_permission.menu = data.iams_permission.menu.filter(item => {
                if (typeArr.includes(activeName) && type[item.moduleCode]) {
                  return type[item.moduleCode] === activeName
                } else {
                  return true
                }
              })
              data.iams_permission.resource = data.iams_permission.resource.filter(item => {
                if (typeArr.includes(activeName) && type[item.moduleCode]) {
                  return type[item.moduleCode] === activeName
                } else {
                  return true
                }
              })
              for (let i of data.iams_permission.menu) {
                temp.permissions.push(i.perms)
              }
              let child = []
              for (let i of data.iams_permission.menu) {
                let haveParent = false
                for (let j of data.iams_permission.menu) {
                  if (i.id == j.pid) {
                    haveParent = true
                  }
                }
                if (!haveParent) {
                  child.push({
                    id: i.id,
                    label: i.perms,
                    child: []
                  })
                }
              }
              for (let i of child) {
                for (let j of data.iams_permission.resource) {
                  if (i.id == j.pid) {
                    i.child.push({ Name: j.perms })
                  }
                }
              }
              for (let i of child) {
                i.child.push({ Name: 'view' })
              }
              temp.new_per_list = child
              data.product_and_permission = temp

              commit('SET_PRODUCT_AND_PERMISSION', data.product_and_permission)
              commit('SET_ROLES', data.roles)
              // 操作权限
              const permissions = filterPermissions(data.product_and_permission.new_per_list)
              commit('SET_PERMISSIONS', permissions)
            } else {
              if (data.product_and_permission) {
                // 验证返回的roles是否是一个非空数组
                commit('SET_PRODUCT_AND_PERMISSION', data.product_and_permission)
                commit('SET_ROLES', data.roles)
                // 操作权限
                const permissions = filterPermissions(data.product_and_permission.new_per_list)
                commit('SET_PERMISSIONS', permissions)
              } else {
                reject(new Error('getInfo: roles must be a non-null array !'))
              }
            }
            // const permissions = state.product_and_permission && state.permissions
            // const value = ['*view_number*view*']
            // const all_permission = '*:*:*'

            // if (value && value instanceof Array && value.length > 0) {
            //   const permissionFlag = value
            //   const hasPermissions = permissions.some(permission => {
            //     return all_permission === permission || permissionFlag.includes(permission)
            //   })
            //   if (!hasPermissions) {
            //     commit('SET_VIEW_NUMBER', false)
            //   } else {
            //     commit('SET_VIEW_NUMBER', true)
            //   }
            // }
            commit('SET_COUNTRY_NAME', data.country_name_en)
            commit('SET_DNC', data.dnc_switch)
            commit('SET_IS_ACCESS_IAMS', data.is_access_iams)
            commit('SET_SHOW_DASHBOARD', data.show_dashboard)
            commit('SET_ID', data.user_id)
            commit('SET_NAME', data.name)
            commit('SET_AVATAR', data.avatar)
            commit('SET_LOGO', data.Logo)
            commit('SET_COMPANY', data.company)
            commit('SET_ISTRAVEL', data.is_travel)
            commit('SET_LANGUAGE', data.language)
            commit('SET_DETAIL_LANGUAGE', data.detail_language)
            commit('SET_APPROVAL', data.show_approval)
            let usertime = {
              value: data.new_timezone_region,
              time: data.tz_postfix
            }
            commit('SET_USERTIME', usertime)
            // 获取用户意向标签
            commit('SET_INTENTION_TAGS', data.intention)
            // 获取用户信息
            commit('SET_USERINFO', data)

            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    closeLoginInfo({ commit }) {
      commit('CLOSE_LOGIN_INFO')
    },
    setLoginInfo({ commit }, detailInfo) {
      commit('SET_LOGIN_INFO', detailInfo)
    },
    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        removeToken()
        resolve()
      })
    },
    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js